export default __webpack_public_path__ + "static/media/SB-BIOLOGY-HIGH-SCHOOL-AP-U1.204f7de5.jpg";